import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import * as S from "./style";
//Icons
import { Circle, CreditCard, Info, Package } from "@phosphor-icons/react";
//hooks
import useLoading from "../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//components
import ImgOrder from "../../../../assets/ImgOrder.png";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
import Loading from "../../../Loading";
import DetailsCustom from "../../Customer/Details";
import DetailsProduct from "../CardDetails";
//utils
import FormatarData from "utils/FormatData";
//Interface
import { IOrder } from "Interfaces/IOrder";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {
  const [data, setData] = useState<IOrder | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`sale/${selectedUrlId}`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalDetails && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalDetails, selectedUrlId]);

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes da Venda"
        subTitle="Veja todos os detalhes disponíveis sobre a armação."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? (
          <Loading />
        ) : (
          <S.Content>
            <S.Infor>
              <S.Status>
                <Circle size={8} weight="fill" />
                {data.sale_info?.status || "-"}
              </S.Status>
            </S.Infor>

            <S.Header>
              <S.ContentImage>
                <S.Image src={ImgOrder} alt="Imagem Óculos" />
              </S.ContentImage>

              <S.ContentInfor>
                <S.Infor>
                  <S.Text>N° da Venda:</S.Text>
                  <span>{data.sale_info?.number_ata || "-"}</span>
                </S.Infor>

                <S.Infor>
                  <S.Text>Data da venda:</S.Text>
                  <span>{FormatarData(data.sale_info?.date_sale, 'default-data') || "-"}</span>
                </S.Infor>

                <S.Infor>
                  <S.Text>Preço:</S.Text>
                  <span>
                    {data.sale_info?.total_amount}
                  </span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              {/* Cliente */}
              <S.Section>
                <S.InforBody>
                  <S.Text>
                    Cliente
                    {data.sale_info?.customer && (
                      <S.Button>
                        <Info
                          size={16}
                          onClick={() => toggleModalVisibility("details")}
                        />
                      </S.Button>
                    )}
                  </S.Text>
                  <span>{data.sale_info?.customer.name || "-"}</span>
                </S.InforBody>

                <S.InforBody>
                  <S.Text>
                    Vendedor
                  </S.Text>
                  <span>{data.sale_info?.seller?.name || "-"}</span>
                </S.InforBody>
              </S.Section>

              {/* Financeiro */}
              <S.Section>
                <S.Text>
                  <CreditCard size={20} />
                  Área Financeira
                </S.Text>
                <S.FeaturedSection>
                  <S.ContentBody>
                    <S.InforBody>
                      <p>Desconto (R$)</p>
                      <span>{data.financial_summary?.total_discounts || '-'}</span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>Tipo do Desconto</p>
                      <span>
                        {data.financial_summary?.promotion.length > 0 &&
                          (data.financial_summary?.promotion[0].type || '-')
                        }
                      </span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>Total (R$)</p>
                      <span>{data.financial_summary?.total_amount || '-'}</span>
                    </S.InforBody>
                  </S.ContentBody>

                  <S.ContentBody>
                    <S.InforBody>
                      <p>Desconto (%)</p>
                      <span>
                        {data.financial_summary?.promotion.length > 0
                          ? (data.financial_summary?.promotion[0].discount_percentage || '0%') :
                          '0%'}
                      </span>
                    </S.InforBody>

                    <S.InforBody>
                      <p>Subtotal (R$)</p>
                      <span>{data.financial_summary?.subtotal || '-'}</span>
                    </S.InforBody>
                  </S.ContentBody>
                </S.FeaturedSection>

              </S.Section>

              {/* Produtos */}
              <S.Section>
                <S.Text>
                  <Package size={20} />
                  Produtos
                </S.Text>
                <S.ContentBody>
                  {
                    data.items.map((item, index) => {
                      return (
                        <DetailsProduct
                          type_product={item.product?.type || '-'}
                          count={index + 1}
                          value_unit={item.unit_price || '0'}
                          code={item.product.name || '-'}
                          amount={item.quantity || 0}
                          total={item.total || '0'}
                          payment={item.payments || []}
                          promotion={item.promotion || null}
                        />
                      )
                    })
                  }
                </S.ContentBody>
              </S.Section>

              {/* <S.InforBody>
                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                <S.InforSmall>
                  Ultima atualização em: {FormatarData(data.updated_at) || "-"}
                </S.InforSmall>
              </S.InforBody> */}
            </S.Body>

            <DetailsCustom
              isOpenModalDetails={isOpenModal("details")}
              setModalClose={() => toggleModalVisibility("details")}
              selectedUrlId={data.sale_info?.customer?.id || null}
            />

          </S.Content>
        )}
      </LayoutDetails>
    );
  }
  return null;
}
